import React from 'react';
import { Table } from 'react-bootstrap';
import Row from './components/Row';

const thStickyStyle = { position: 'sticky', background: 'whitesmoke', border: '1px solid #ddd', top: 0 };

const AdkHourFactorTable = ({ factors, onChange }) => {
    const countries = Object.keys(factors);
    let headers = [];
    let rows = [];

    for(let i = 0; i < 24; i++) headers.push(<th style={thStickyStyle}>{i}</th>);

    countries.forEach(country => {
        const countryFactors = factors[country] ? factors[country] : {};

        rows.push(<Row country={country} factors={countryFactors} onChange={onChange}/>);
    });
  
    return (
        <Table bordered style={{ textAlign: 'center', verticalAlign: 'middle', borderCollapse: 'separate' }}>
            <thead>
                <tr>
                    <th style={{ ...thStickyStyle, background: 'white' }}>Day/Hour</th>
                    {headers}
                </tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
        </Table>
    )
};

export default AdkHourFactorTable;



// WEBPACK FOOTER //
// ./src/scenes/AdkCountryHourFactor/components/Table/index.js